import { Observable } from 'rxjs/Observable';
import { Injector } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../../shared/auth/auth.service';
import { Principal } from '../../../shared/auth/principal.service';

export class AuthExpiredInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
                .do((event: HttpEvent<any>) => {}, (error: any) => {
                    if (error instanceof HttpErrorResponse) {
                        if (error.status === 401 || error.status === 403) {
                            let principal: Principal = this.injector.get(Principal);
                            if (principal.isAuthenticated()) {
                                let auth: AuthService = this.injector.get(AuthService);
                                auth.authorize(true);
                            }
                        }
                    }
                });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/http/interceptor/auth-expired.interceptor.ts